import { Component, OnInit } from '@angular/core';
import { StripeService } from 'src/app/services/stripe.service';
import { StripeIntent } from 'src/app/models/stripe/stripe-intent';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Order } from 'src/app/models/order';
import { OrderService } from 'src/app/services/order.service';
declare var Stripe;
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-stripe',
  templateUrl: './stripe.component.html',
  styleUrls: ['./stripe.component.scss']
})
export class StripeComponent implements OnInit {
  private publishableKey:string;
  private intent: StripeIntent;
  private stripe;
  private cardElement: any;
  public errorMessage=null;
  public stripeForm:FormGroup;
  private order: Order;

  constructor(private stripeService: StripeService, private orderService: OrderService) {
    this.publishableKey=environment.stripePublishableKey;
    this.stripe=Stripe(this.publishableKey);


    console.log(this.stripe);

    this.stripeForm = new FormGroup({
      'name': new FormControl(null, Validators.required),
      'address_line_1': new FormControl(null, Validators.required),
      'address_line_2': new FormControl(null, Validators.required),
      'town': new FormControl(null, Validators.required),
      'county': new FormControl(null, Validators.required),
      'postcode': new FormControl(null, Validators.required),
    });
  }

  ngOnInit() {
    this.stripeService.createIntent(1199, '').subscribe(res=>{
      this.intent = res;
      var elements = this.stripe.elements();
      this.cardElement = elements.create('card');
      this.cardElement.mount('#card-element');
    })
  }


  completePayment(){
    let order = new Order;
    order.intent_id = this.intent.id;
    order.name = this.stripeForm.get('name').value;
    order.address_line_1 = this.stripeForm.get('name').value;
    order.address_line_2 = this.stripeForm.get('name').value;
    order.town = this.stripeForm.get('name').value;
    order.county = this.stripeForm.get('name').value;
    order.postcode = this.stripeForm.get('name').value;
    order.amount=this.intent.amount;

    this.orderService.createOrder(order).subscribe(order=>{
    })

    /*
    this.errorMessage = null;
    this.stripe.handleCardPayment(
      this.intent.client_secret, this.cardElement, {
        payment_method_data: {
          billing_details: {name: "Daniel Dimmick"}
        }
      }
    ).then(function(result) {
      if (result.error) {
          this.errorMessage = result.error.message;
      } else {
        console.log(result);
      }
    }.bind(this));
    */
  }

}
